import { render } from "./pfdetail.vue?vue&type=template&id=1d32df66&scoped=true"
import script from "./pfdetail.vue?vue&type=script&lang=js"
export * from "./pfdetail.vue?vue&type=script&lang=js"

import "./pfdetail.vue?vue&type=style&index=0&id=1d32df66&lang=scss&scoped=true"
import "./pfdetail.vue?vue&type=style&index=1&id=1d32df66&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d32df66"]])

export default __exports__